import { application } from "./application"
import ThemeController from "./theme_controller"
import SidebarController from "./sidebar_controller"
import ScrollToBottomController from "./scroll_to_bottom_controller"
import ResetFormController from "./reset_form_controller"
import RoleProjectsController from "./role_projects_controller"
import PricingToggleController from "./pricing_toggle_controller"
import NotificationToastsController from "./notification_toasts_controller"
import TaskBoardController from "./task_board_controller"

import AppointmentOfferingController from "./appointment_offering_controller"
import AppointmentCalendarController from "./appointment_calendar_controller"
import ChartController from "./chart_controller"
import WidgetBridgeController from "./widget_bridge_controller"
import WidgetChannelController from "./widget_channel_controller"
import FeedbackBridgeController from "./feedback_bridge_controller"
import ClipboardController from "./clipboard_controller"
import TypingController from "./typing_controller"
import TypingIndicatorController from "./typing_indicator_controller"
import CustomAttributesController from "./custom_attributes_controller"
import MentionController from "./mention_controller"
import OwnMessagesController from "./own_messages_controller"

application.register("theme", ThemeController)
application.register("sidebar", SidebarController)
application.register("scroll-to-bottom", ScrollToBottomController)
application.register("reset-form", ResetFormController)
application.register("role-projects", RoleProjectsController)
application.register("pricing-toggle", PricingToggleController)
application.register("notification-toasts", NotificationToastsController)
application.register("task-board", TaskBoardController)
application.register("appointment-offering", AppointmentOfferingController)
application.register("appointment-calendar", AppointmentCalendarController)
application.register("chart", ChartController)
application.register("widget-bridge", WidgetBridgeController)
application.register("widget-channel", WidgetChannelController)
application.register("feedback-bridge", FeedbackBridgeController)
application.register("clipboard", ClipboardController)
application.register("typing", TypingController)
application.register("typing-indicator", TypingIndicatorController)
application.register("custom-attributes", CustomAttributesController)
application.register("mention", MentionController)
application.register("own-messages", OwnMessagesController)
